<template>
  <div class="biasfx2">
    <ModalVideoBiliBili
      v-if="showModal"
      :id="showModalId"
      @close="closeModal"
    />
    <ModalBuy v-show="showModalBuy" />
    <Banner :with-bias-banner="true" />
    <div style="position: relative;">
      <BiasFx2Banner />
    </div>
    <div
      id="section_00"
      class="heroArea bias-fx2-hero row"
      @click="goToBuyNow"
    >
      <!-- <div
        class="col-xs-12 heroArea-title"
        data-swtp-main-title-align=""
      >
        <h3
          class="subtitle textCenter"
          data-swtp-text=""
          style="color: white; margin: 0; opacity: 1; font-size:30px; font-weight: 600;"
        >
          音色的新纪元
        </h3>
        <h1
          class="main-title"
          style="margin: 0; font-size:80px;"
        >
          BIAS FX 2
        </h1>
      </div> -->
      <!-- <button @click="goToBuyNow">
        立即抢优惠
      </button>-->
    </div>
    <div
      id="section_00_space"
      class="gapArea"
    />

    <section class="section sound section-dynamic-amp-engine">
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div
            class="inner"
            style="padding-bottom: 0; padding-top: 6rem;"
          >
            <div class="column-content">
              <div class="fx2-key-feature-container">
                <div class="fx2-key-feature fx2-key-feature-left fx2-key-feature-1">
                  <h3>经过彻底的重新工程设计</h3>经过彻底的重新工程设计、具有更高精度的 DSP 引擎，凭借数百项改进带来各式各样细节丰富、具有终极响应的吉他音色。
                </div>
                <div class="fx2-key-feature fx2-key-feature-right fx2-key-feature-2">
                  <h3>超级真实的吉他匹配技术</h3>Positive Grid 新开发的独家吉他匹配和模拟技术，能以惊人的真实度将你的吉他变成另一个型号。
                </div>
                <div class="fx2-key-feature fx2-key-feature-left fx2-key-feature-3">
                  <h3>新的音箱、单块和机架效果器</h3>大量经过全新改进的音箱、单块和 HD 机架效果器，给你的吉他音色带来无与伦比的深度和宽度。
                </div>
                <div class="fx2-key-feature fx2-key-feature-right fx2-key-feature-4">
                  <h3>惊艳而且先进的建模效果器</h3>全新的法兹、时间及和声建模效果器，能以激动人心的独特吉他音色和效果来提升你的作品质量。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="section_video"
      class="row textCenter introArea videoArea section-spacing-fix"
    >
      <div class="col-xs-12">
        <div
          class="video-container max-width-fix-text"
          style="padding-325 0px"
        >
          <div class="item col-xs-12 col-sm-12">
            <VideoCard
              :image="'fx2-new-era.jpg'"
              :large="true"
              @playVideo="openModal('49488345')"
            />
            <div class="video-caption textCenter">
              BIAS FX 2 概述 - 音色的新纪元
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="dynamic-amp-engine"
      class="section sound section-dynamic-amp-engine"
    >
      <div class="grid-container radial-grident-color-1">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-1 color-1-border">新特性</span>
              </div>
              <h2 class="title color-1">
                轻松上手 一应俱全
              </h2>
              <h3 class="subtitle mobile-hide">
                将你的电脑变成一体化的吉他工作站
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  想动动手指就能拥有著名的经典款和现代款音箱和效果器？BIAS FX 2 就提供这一切，并且它还是 MAC 和 PC 系统上针对电吉他、贝斯或原声吉他的一套虚拟设备，不仅直观而且可完全定制。它可以作为独立的应用程序来使用，让你在演奏、练习和飙琴的时候注入新的音色和创造力，同时无需任何其它的软件或数字音频工作站。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/overview/section_01_dynamic_engine_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="pedalboard-paradise"
      class="section sound section-pedalboard-paradise"
    >
      <div class="grid-container radial-grident-color-2">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-2 color-2-border">新特性</span>
              </div>
              <h2 class="title color-2">
                单块的天堂
              </h2>
              <h3 class="subtitle mobile-hide">
                数以千计声音逼真、模拟味十足的单块
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  BIAS FX 2 自带的单块效果器可以通过从音色云下载数以千计共享的定制单块来进行扩展。音色云是 Positive Grid 为乐手、工程师和制作人打造的一个全球性社交网络。但是还远不止这些。你可以利用 BIAS FX 2 精英版里完全集成的 BIAS Pedal 软件来轻松地改装你的失真、延时和调制单块，从而创造出独一无二的单块效果链和音色。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
              style="max-width: initial; width: 100%;"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder image-desktop"
                      src="@/assets/bias-fx2/overview/section_02_pedalboard_paradise_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                    <img
                      class="lazyload lazeload-placeholder image-mobile"
                      src="@/assets/bias-fx2/overview/section_02_pedalboard_paradise_kv_mobile.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="hyper-realistic-guitar-match"
      class="section sound section-advanced-guitar-modeler"
    >
      <div class="grid-container radial-grident-color-3">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-3 color-3-border">新特性</span>
              </div>
              <h2 class="title color-3">
                突破性的吉他匹配技术
              </h2>
              <h3 class="subtitle mobile-hide">
                超级真实、精确的吉他模拟
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  在录音棚里为了录下一轨必须得换一把吉他？或者在舞台上为了下一首曲子得拿起另一把吉他？忘了这样的事情吧。有了 BIAS FX 2 突破性的吉他匹配技术，你可以将你的吉他 - 任何吉他都行 - 变成一系列精心收藏的传奇型号，其中每一款的精确再现都细致到拾音器、琴体形状和琴体的厚度。不需要特殊的拾音器就能让你的吉他听起来像一把经典的美式吉他、一把老式的 LP 吉他以及更多款不同的吉他。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/overview/section_03_guitar_match_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="grid-half-item grid-full-width introArea"
          style="padding: 0; padding-bottom: 2rem;"
        >
          <div
            class="video-container max-width-fix-text"
            style="padding-top: 0px"
          >
            <div class="video-caption textCenter">
              <VideoCard
                :image="'fx2-guitar-match.jpg'"
                :large="true"
                @playVideo="openModal('49488641')"
              />吉他的百变魔法 - BIAS FX 2 吉他匹配技术
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="next-level-effects"
      class="section sound section-the-next-level-effects"
    >
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-4 color-4-border">新特性</span>
              </div>
              <h2 class="title color-4">
                应用广泛、更高水准的效果器
              </h2>
              <h3 class="subtitle mobile-hide">
                让你的作品听起来更具有旋律性、更大胆、更深入、更宽广
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  新的和声、法兹以及时间建模效果器，让你的录音和现场表演超越平常的极限。BIAS FX 2 先进的建模效果器套装，可以让你创造出复古和现代的法兹单块来得到更多的沙砾感和更长的延音，还可以创造出基于时间的效果器来获得更有深度的音色，更能即刻创造出带有多重声部的合奏旋律线。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/overview/section_04_next_level_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <section class="section sound continue-above-section">
      <div class="grid-half-container mobile-hide">
        <div class="grid-half-column left">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 3em;">
                    强化你的声轨
                    <br>全新的录音棚机架效果器
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    从必备的实用型工具到具有奶油般音色的复古效果器和上乘的现代外部设备，BIAS FX 2 的 8 个全新录音棚机架效果器 - EchoreX HD 磁带延时、三重合唱、电子管压缩、弹簧混响、哇音等等 - 能将你的项目打磨得像顶尖录音棚出来的超高解析度作品。
                  </p>
                </div>
                <div class="column-content">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-rack-view-2.jpg"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 3em;">
                    探索历史 塑造未来
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    利用新的 Echorec 磁鼓延时、电子管多段压缩、旋转扬声器上先进的 DSP 模拟技术来塑造你的完美音色。一系列全新和改进的高端机架效果器给你的吉他和贝斯音色增添无与伦比的深度和宽度。其中的每一款都是建模到元件的程度，并且在细节上也是极为注重。
                  </p>
                </div>
                <div class="column-content">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-rack-multicomp-2.jpg"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="celestion"
      class="section sound section-official-celestion-speakers"
    >
      <div class="grid-container radial-grident-color-5">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <!-- <span class="color-5 color-5-border">新特性</span> -->
              </div>
              <h2 class="title color-5">
                内置 Celestion
                <span class="r-symbol">®</span> 扬声器
              </h2>
              <h3 class="subtitle mobile-hide">
                世界一流的 Celestion 官方箱体
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  我们与吉他扬声器领域最值得信赖的品牌Celestion达成了合作。相对于其他品牌来说，Celestion的驱动单元更常被用来创造经典歌曲里的优秀吉他音色。他们的脉冲响应(IR)受到吉他手的广泛喜爱，其中包括了Pete Thorn、Scott Henderson和George Lynch。别再加载一个个单独的文件了 - 只需选择一个定制的Celestion箱体并试着来回移动虚拟的话筒。其余的就让BIAS FX 2帮你搞定！
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/overview/section_06_celestion_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <section
      id="tonecloud"
      class="section sound section-tonecloud"
    >
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-6 color-6-border">新特性</span>
              </div>
              <h2 class="title color-6">
                音色云
              </h2>
              <h3 class="subtitle mobile-hide">
                50000 多个在线预设为你开启了音色的世界
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  还在为了扩展你的吉他音色而无休止地寻找、购买额外的预置音色吗？大可不必。现在你可以直接访问超过 50000 个预置设定，这些针对定制音箱、单块和单块效果链的预设是由不断扩展中的音色云在线社区提供分享。再也不需要打开其它的软件了。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/overview/section_07_tone_cloud_kv.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <section class="section sound continue-above-section two-column-adjust-container-2">
      <div class="grid-half-container mobile-hide">
        <div class="grid-half-column left">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 3em;">
                    经过极大改进的工作流程加快了音色召回的速度
                  </h3>
                  <p
                    class="desktop-text"
                    style="min-height: 150px;"
                  >
                    在灵感迸发的时候，你不必为了找到一个完美的音色而踏上探索之旅。得益于音色云中所有预设上的关联标签和关键词，现在快速地找到并下载合适的预设变得前所未有的容易，你的创作思路再也不会被打断了。
                  </p>
                </div>
                <div class="column-content">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-workflow-2.jpg"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 3em;">
                    最优秀的厂家新预设和在线预设
                  </h3>
                  <p
                    class="desktop-text"
                    style="min-height: 150px;"
                  >
                    新的音色可以激发出新的连复段和歌曲。有了 BIAS FX 2，你再也不会有写作的障碍了。由世界著名的艺术家、录音棚工程师和录音乐手制作的超过 200 个新的厂家单块效果链预设，能让你的创作魔力无限爆发。
                  </p>
                </div>
                <div class="column-content">
                  <figure>
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-tonecloud-2.jpg"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="recording-and-performance"
      class="section sound section-recording-and-performance mobile-hide"
    >
      <div class="grid-container">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-7 color-7-border">新特性</span>
              </div>
              <h2 class="title color-7">
                录音与表演
              </h2>
              <h3 class="subtitle">
                让歌曲过渡、现场表演和录音棚混音变得更加紧凑
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  不管你是一名怀抱志向的吉他手还是一位经验老道的专业乐手，也无论是在录音棚里还是在舞台上，BIAS FX 2 都能让歌曲的即时过渡、动人心魄的效果切换以及让人耳朵一亮的混音变得前所未有的容易。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-pedal-view.jpg"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <section
      class="section sound continue-above-section width-adjust-container four-column-adjust-container mobile-hide"
    >
      <div class="grid-half-container">
        <div class="grid-half-column left">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 5em;">
                    场景设定 - 一键切换你的单块效果链
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    在 BIAS FX 2 里的每一个预置音色都有 4 个你可以创建和保存的场景设定，这样你就可以召回多个不同的但又紧密关联的单块效果链场景。只需点击一下，你就可以针对你的主音 Solo 打开过载和延时效果并同时关闭之前在歌曲主歌部分用到的合唱效果 - 所有这一切都不会影响到预置音色的其它设定。或者，也可以针对歌曲的不同部分从一个单块效果链设置即刻切换成另一个单块效果链设置 - 每一个都有完全不同的均衡、混响以及其他设定。
                  </p>
                </div>
                <div class="column-content">
                  <!-- <figure> -->
                  <!-- <img class="lazyload lazeload-placeholder" src="{{cdn 'webdav:img/bias-amp-2/sound-page/amp_match/Amp Match.jpg'}}" width="859" height="624" alt="amp-match"> -->
                  <!-- </figure> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 5em;">
                    重新设计的工作流程让录音工作变得更简单、更有成效
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    经过重新设计的用户界面包含了一个新的预设管理器，使管理更加简单，查找、召回和预听收藏的单块效果链设置变得更加迅速。将你每一个的定制单块效果链设置拍个快照，然后就可以针对当前歌曲在它们之间随时做最合适的即时 A/B 切换。或者也可以在过载节奏吉他音色与咆哮的主音 Solo 音色来回切换的时候，利用快照来实现音箱设置的即时切换。
                  </p>
                </div>
                <div class="column-content">
                  <!-- <figure> -->
                  <!-- <img class="lazyload lazeload-placeholder" src="{{cdn 'webdav:img/bias-amp-2/sound-page/amp_match/Amp Match.jpg'}}" width="859" height="624" alt="amp-match"> -->
                  <!-- </figure> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column left">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 5em;">
                    利用 MIDI 自动化来增强和优化复杂的混音
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    BIAS FX 2 的强大 MIDI 功能可以让你创造出令粉丝着迷的惊人的即时混音变化以及流畅的渐变过渡效果，而这利用的就是针对歌曲的每一个部分所做的参数自动变化 - 这同时会减少你在项目上花费的工作时间。有了 BIAS FX 2，你就可以将 MIDI 指令分配给几乎每一个可用的参数，其中包括音量控制、单独的效果参数、吉他模拟的选择、循环录音机功能等等众多的选项。
                  </p>
                </div>
                <div class="column-content">
                  <!-- <figure> -->
                  <!-- <img class="lazyload lazeload-placeholder" src="{{cdn 'webdav:img/bias-amp-2/sound-page/amp_match/Amp Match.jpg'}}" width="859" height="624" alt="amp-match"> -->
                  <!-- </figure> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-half-column right">
          <div class="grid-half-item">
            <div>
              <div class="line" />
              <div class="inner">
                <div class="column-content">
                  <h3 style="min-height: 5em;">
                    创造独特的混合式音箱和震撼的立体声音箱设置
                  </h3>
                  <p
                    class="desktop-text"
                  >
                    在 BIAS FX 2 里，你演奏时用到的音箱只受限于你的想象力。你可以利用双音箱设置来从两个单独的音箱里筛选出想要的部分 – 包括它们的脉冲响应、箱体、均衡、甚至是使用的话筒 – 并将其组合成一个独一无二的、别人没有的混合式音箱。或者保留两个音箱的原样，将两个音箱的信号并联并将它们的声像分别打到极左和极右，凭借左右声道上完全不同的吉他音色来创造一个超宽的立体设置。
                  </p>
                </div>
                <div class="column-content">
                  <!-- <figure> -->
                  <!-- <img class="lazyload lazeload-placeholder" src="{{cdn 'webdav:img/bias-amp-2/sound-page/amp_match/Amp Match.jpg'}}" width="859" height="624" alt="amp-match"> -->
                  <!-- </figure> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <section
      id="sound"
      class="section sound section-looper mobile-hide"
    >
      <div class="grid-container radial-grident-color-8">
        <div class="grid-half-item grid-full-width">
          <div class="inner">
            <div class="column-content">
              <div class="new-seal">
                <span class="color-8 color-8-border">新特性</span>
              </div>
              <h2 class="title color-8">
                智能循环录音机/伴奏播放器
              </h2>
              <h3 class="subtitle">
                保留住转瞬即逝的音乐构思
              </h3>
              <div>
                <p
                  class="desktop-text text"
                >
                  利用 BIAS FX 2 内置的录音机，在灵感迸发的时候只需一个简单的点击就能快速录下连复段、伴奏动机和歌曲的想法。然后通过 BIAS FX 2 的单块、音箱和机架效果器来循环回放你的录音，这样就能针对新歌曲构思来细致调节出完美的定制音色。你也不会丢失那个演奏完美的连复段 - 只需将它导出成 WAV 文件就可以导入到数字音频工作站的一个新轨道上。有了 BIAS FX 2，在循环录音机里录下的歌曲想法，就可以作为一个基础使用在一个新的多轨录音当中。
                </p>
              </div>
            </div>
            <div
              class="gallery"
              data-group="1"
            >
              <div class="gallery-main-content">
                <div
                  id="gallery-item-group1-1"
                  class="gallery-item"
                  aria-hidden="true"
                >
                  <figure class="image-container">
                    <img
                      class="lazyload lazeload-placeholder"
                      src="@/assets/bias-fx2/biasfx2-looper.png"
                      width="859"
                      height="624"
                      alt="amp-match"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      id="buy"
      class="buy"
    >
      <h2>立即购买</h2>
      <!-- <h3>双11特惠机会难得，<br class="desktop-hide">BIAS FX 2 <span>全面3折！</span></h3> -->
      <div
        class="softwares h-full w-full relative m-0 p-5 flex items-baseline justify-center flex-wrap"
      >
        <Software
          :img="SoftwareImageLite"
          :name="'BIAS FX 2'"
          :sku="'L2103'"
          :version-text="'标准版'"
          :description="'定制性超强的吉他音箱和效果处理器'"
          :sale-section="{
            enableIcon: false
          }"
          :features="[
            {
              title: '新特性：',
              list: [
                '总计 30 款新音箱',
                '总计 43 款新效果器',
                '总计 70 个新的厂家预设',
                '吉他匹配功能 – 基本包（4 种型号）',
                '新的循环录音机/伴奏播放器',
                '极大改进的新 DSP 引擎',
                '在音色云上创建和下载上万种音色预设',
                '操作方便的新用户界面',
                '带有多个信号分离器的双信号线路',
                '数以百计的改进'
              ]
            }
          ]"
          :price="getPrices('L2103', 0)"
          :price-ref="getPrices('L2103', 2)"
          :promo-price="getPrices('L2103', 1)"
          :owned="activeLicenseTier.includes('std')"
          tmall-link="https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-23474728918.21.64e545ceovIwBB&id=641516803866&rn=893b2d044b91bd7c39ae9c9ffe149995&abbucket=20"
        />
        <Software
          :img="SoftwareImageStandard"
          :name="'BIAS FX 2'"
          :sku="'L2102'"
          :version-text="'专业版'"
          :description="'解锁更多的音箱、效果和音色的可能性'"
          :sale-section="{
            enableIcon: false
          }"
          :features="[
            {
              title: '除了标准版的所有特性之外还包括：',
              list: [
                '总计 60 款新音箱',
                '总计 115 款新效果器',
                '总计 130 个新的厂家预设',
                '吉他匹配功能 – 专业包（8 种型号）',
                '总计 14 款 HD 机架效果器',
                '新的 MIDI/自动化功能',
                '专门的 IR 加载器',
                '全新的定制艺术家预置音色'
              ]
            }
          ]"
          :price="getPrices('L2102', 0)"
          :price-ref="getPrices('L2102', 2)"
          :promo-price="getPrices('L2102', 1)"
          :owned="activeLicenseTier.includes('pro')"
          tmall-link="https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-23474728918.21.5b156cfac33dV8&id=641518135030&rn=e1309b5970d62022b2f2e9b14420d489&abbucket=20"
        />
        <Software
          :img="SoftwareImagePro"
          :name="'BIAS FX 2'"
          :version-text="'精英版'"
          :sku="'L2101'"
          :description="'终极的吉他音箱和效果处理'"
          :sale-section="{
            enableIcon: false
          }"
          :features="[
            {
              title: '除了专业版的所有特性之外还包括：',
              list: [
                '总计 100 款新音箱',
                '总计 122 款新效果器',
                '总计 210 个新的厂家预设',
                '吉他匹配功能 – 精英包（20 种型号）',
                '总计 18 款 HD 机架效果器',
                '新的法兹建模效果器',
                '新的时间建模效果器',
                '新的和声建模效果器',
              ]
            }
          ]"
          :price="getPrices('L2101', 0)"
          :price-ref="getPrices('L2101', 2)"
          :promo-price="getPrices('L2101', 1)"
          :owned="activeLicenseTier.includes('elite')"
          tmall-link="https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-23474728918.21.76794374uYn1AF&id=641518075781&rn=afff77f7412caef1135f2289b29fccf1&abbucket=20"
        />
        <!-- <span class="note">
          *本活动不与其他优惠併用
        </span>-->
      </div>
    </section>
    <!-- <section class="buy expansions">
      <h2>扩展包</h2>
      <div
        class="softwares h-full w-full relative m-0 p-5 flex items-baseline justify-center flex-wrap"
      >
        <Software
          :img="PackAcoustic"
          :sku="'L2013'"
          :description="'原声扩展包带来了独特的原声影像技术，可以让你精确地模拟不同的原声吉他拾音器。'"
          :features="[
            {
              title: '包括的单块 :',
              list: [
                'Acoustic EQ (EQ)',
                'Acoustic Chorus (Mod)',
                'Acoustic Reverb (Reverb)',
                'Acoustic Image (EQ)',
                'Acoustic Simulator (EQ)',
              ]
            },
            {
              title: '包括的前置放大器 :',
              list: [
                'Acoustic Preamp (Drive)'
              ]
            }
          ]"
          :price="getPrices('L2013', 0)"
          :price-ref="getPrices('L2013', 2)"
          :promo-price="getPrices('L2013', 1)"
          :show-img="true"
          :owned="isPackActive('L2013')"
          :name="'原声扩展包'"
          :sale-section="{
            enableIcon: false
          }"
          :requirements="['＊需要搭配 BIAS FX 1/2']"
          :show-limited-time-icon="false"
        />
        <Software
          :img="PackMetal"
          :sku="'L2011'"
          :description="'解锁由 Jeff Loomis 和 Keith Merrow 打造的签名款高增益音箱與单块，呈现凶猛的吉他音色。'"
          :features="[
            {
              title: '包括的单块 :',
              list: [
                'Merrow Gate (Gate)',
                'Merrow Drive (Drive)',
                'Loomis OD (Drive)',
                'Loomis PQ (EQ)',
                'Frostburn Chorus (Mod)',
                'Frostburn Delay (Delay)'
              ]
            },
            {
              title: '包括的音箱 :',
              list: [
                'Loomis Metal (HI Gain)',
                'Merrow Fire (HI Gain)',
                'Merrow 5153 (HI Gain)',
                'Frostburn Fire (HI Gain)',
                'Loomis 120 (Acoustic)',
                'Frostburn Ice (Acoustic)'
              ]
            }
          ]"
          :price="getPrices('L2011', 0)"
          :price-ref="getPrices('L2011', 2)"
          :promo-price="getPrices('L2011', 1)"
          :show-img="true"
          :owned="isPackActive('L2011')"
          :name="'金属扩展包'"
          :sale-section="{
            enableIcon: false
          }"
          :requirements="['＊需要搭配 BIAS FX 1/2']"
          :show-limited-time-icon="false"
        />
        <Software
          :img="PackBass"
          :sku="'L2012'"
          :description="'贝斯扩展包帶來最受欢迎和通用的贝斯效果器集合。'"
          :features="[
            {
              title: '包括的单块 :',
              list: [
                'Bass Compressor (Comp)',
                'Bass DI Driver (Drive)',
                'Bass Deluxe Drive (Drive)',
                'Bass EQ (EQ)',
                'Bass Chorus (Mod)',
                'Bass Octave (Pitch/Filter)',
                'Bass Envelope (Pitch/Filter)'
              ]
            }
          ]"
          :price="getPrices('L2012', 0)"
          :price-ref="getPrices('L2012', 2)"
          :promo-price="getPrices('L2012', 1)"
          :show-img="true"
          :owned="isPackActive('L2012')"
          :name="'贝斯扩展包'"
          :sale-section="{
            enableIcon: false
          }"
          :requirements="['＊需要搭配 BIAS FX 1/2']"
          :show-limited-time-icon="false"
        />
        <Software
          :img="PackCelClassic"
          :sku="'L1114'"
          :description="'官方的 Celestion 经典扩展包，给你带来 5 款 Celestion 百变龙扬声器中最受追捧的经典型号。'"
          :features="[
            {
              title: '包括：',
              list: [
                'Celestion Vintage 30',
                'Celestion Blue',
                'Celestion G12H Anniversary',
                'Celestion G12-65',
                'Celestion G12M Greenback'
              ]
            },
            {
              title: '对应至三种箱体样式 :',
              list: [
                '1x12',
                '2x12',
                '4x12'
              ]
            }
          ]"
          :price="getPrices('L1114', 0)"
          :price-ref="getPrices('L1114', 2)"
          :promo-price="getPrices('L1114', 1)"
          :show-img="true"
          :owned="isPackActive('L1114')"
          :name="'Celestion 经典扩展包'"
          :sale-section="{
            enableIcon: false
          }"
          :requirements="['＊总计 15 款箱体', '＊需要搭配 BIAS FX 1/2 或 BIAS AMP 1/2']"
          :show-limited-time-icon="false"
        />
        <Software
          :img="PackCelModern"
          :sku="'L1111'"
          :description="'通过额外添加 5 款官方的 Celestion 百变龙扬声器到现有的箱体库，给你带来更加多样化的经典音色。'"
          :features="[
            {
              title: '包括：',
              list: [
                'Celestion G12H-75 Creamback',
                'Celestion G12M-65 Creamback',
                'Celestion Neo Creamback',
                'Celestion G12H-150 Redback',
                'Celestion A-Type speakers'
              ]
            },
            {
              title: '对应至三种箱体样式 :',
              list: [
                '1x12',
                '2x12',
                '4x12'
              ]
            }
          ]"
          :price="getPrices('L1111', 0)"
          :price-ref="getPrices('L1111', 2)"
          :promo-price="getPrices('L1111', 1)"
          :show-img="true"
          :owned="isPackActive('L1111')"
          :name="'Celestion 现代复古扩展包'"
          :sale-section="{
            enableIcon: false
          }"
          :requirements="['＊总计 15 款箱体', '＊需要搭配 BIAS FX 1/2 或 BIAS AMP 1/2']"
          :show-limited-time-icon="false"
        />
      </div>
    </section> -->
    <section class="requirements">
      <div>
        <h4>购买注意事项</h4>
        <ul class="notes">
          <li>人民币价格实际上会随汇率浮动</li>
          <li>付款时的换汇手续费由购买者负担</li>
          <li>
            退款政策请
            <a
              href="https://s3-us-west-2.amazonaws.com/cn.positivegrid.com/refund/index.html"
            >见此</a>
          </li>
        </ul>
      </div>
      <div>
        <h4>产品内容包括</h4>
        <ul class="checkmark">
          <li>即时数字下载</li>
          <li>Windows：独立版、VST、AAX</li>
          <li>OS X / macOS：独立版、AU、VST、AAX</li>
        </ul>
      </div>
      <div>
        <h4>系统需求</h4>
        <ul class="checkmark">
          <li>OS X 10.11 或 macOS 10.12/10.13/10.14，酷睿i5</li>
          <li>Windows 8 或更高版本，英特尔酷睿 i5 或同等产品，4 GB 内存</li>
        </ul>
      </div>
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasFx2Banner from '@/components/bias-fx2-banner'
import Banner from '@/components/banner'
import VideoCard from '@/components/video-card'
import Software from '@/components/software'

import ModalVideoBiliBili from '@/components/modal-video-bilibili'
import ModalBuy from '@/components/modal-buy'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import SoftwareImageLite from '@/assets/fx-software/image-lite@2x.png'
import SoftwareImageStandard from '@/assets/fx-software/image-standard@2x.png'
import SoftwareImagePro from '@/assets/fx-software/image-pro@2x.png'

import PackAcoustic from '@/assets/fx-software/pack/acoustic.png'
import PackMetal from '@/assets/fx-software/pack/metal.png'
import PackBass from '@/assets/fx-software/pack/bass.png'
import PackCelModern from '@/assets/fx-software/pack/celestion.png'
import PackCelClassic from '@/assets/fx-software/pack/celclassic.png'

import { mapState, mapActions, mapGetters } from 'vuex'
import store from '@/store'
import urls from '@/urls'
import axios from 'axios'

export default {
  name: 'Index',
  store,
  components: {
    Banner,
    VideoCard,
    Software,
    ModalVideoBiliBili,
    FooterWeixin,
    FooterCommon,
    BiasFx2Banner,
    ModalBuy
  },
  data () {
    return {
      showModal: false,
      showModalId: null,
      SoftwareImageLite,
      SoftwareImageStandard,
      SoftwareImagePro,
      PackCelClassic,
      PackBass,
      PackCelModern,
      PackMetal,
      PackAcoustic,
      productsData: []
    }
  },
  computed: {
    ...mapGetters('Auth', {
      isLoginValid: 'isLoginValid'
    }),
    ...mapState('Auth', {
      token: 'token'
    }),
    ...mapState('ModalBuy', {
      showModalBuy: 'show'
    }),
    ...mapState('Software', {
      ownedLicense: 'ownedLicense'
    }),
    ...mapGetters('Software', {
      activeLicenseTier: 'getActiveLicenseTier',
      isPackActive: 'isPackActive'
    })
  },
  mounted: function () {
    if (this.isLoginValid) {
      this.getOwnedLicense({ token: this.token, product: 'fx2' })
    }
    if (this.$route.hash === '#buy') {
      this.goToBuyNow()
    }
    this.fetchProductPrice()
  },
  methods: {
    ...mapActions('Software', {
      getOwnedLicense: 'getOwnedLicense'
    }),
    openModal (url) {
      this.showModal = true
      this.showModalId = url
    },
    closeModal () {
      this.showModal = false
    },
    goToBuyNow () {
      this.$router.push('/bias-fx2/#buy')
      window.document.querySelector('#buy').scrollIntoView()
    },
    getPrices (sku, priceIndex) {
      let value = 0
      this.productsData.forEach(product => {
        if (product.product.sku === sku) {
          switch (priceIndex) {
            // price
            case 0:
              value = product.price
              break
            // discount
            case 1:
              value = product.discount
              break
            // cn price
            case 2:
              value = product.cn_price
              break
            default:
              value = 0
              break
          }
        }
      })
      return value
    },
    async fetchProductPrice () {
      const result = await axios({
        method: 'GET',
        url: `${urls.NEW_API_URL}/china/sales`
      })

      this.productsData = result.data
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";

.heroArea {
  &.bias-fx2-hero {
    min-height: 125vw;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("../assets/bias-fx2/overview/hero.jpg");
    background-position: center 45px;
    cursor: pointer;

    @include breakpoint("medium") {
      min-height: 620px;
      background-image: url("../assets/bias-fx2/overview/hero.jpg");
    }
    @include breakpoint("large") {
      background-image: url("../assets/bias-fx2/overview/hero.jpg");
    }
  }
}

.softwares {
  width: 90%;
  margin: 0 auto;
  max-width: 1200px;

  &-desc {
    padding: 0;
    text-align: center;
    p {
      color: #fff6d1;
    }
  }
}

#buy:before {
  display: block;
  content: " ";
  margin-top: -75px;
  height: 75px;
  visibility: hidden;
}

.buy {
  h2 {
    text-align: center;
    margin-bottom: 0;
  }

  h3 {
    text-align: center;
    color: #ffdd00;
    font-weight: normal;

    span {
      font-weight: bold;
      font-size: 36px;
      letter-spacing: 0.5rem;
    }
  }
}

.buy.expansions > .promo {
  display: flex;
  flex-direction: row;
  max-height: 4rem;
  justify-content: center;
  align-items: h3 {
    margin: 0;
    padding: 0;
  }
  img {
    object-fit: contain;
  }
}

a:visited {
  color: #d7d7d7;
}

.softwares-desc p {
  margin: 0;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/pages/bias-fx2.vue